/*
 * Module for handling localized and default category name
 */

define(["marionette", "messaging/messenger", "./categoryNameView"], function (
  Marionette,
  Messenger,
  CategoryNameView,
) {
  var CategoryNamesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categoryDefaultName";
      this.region = options.region;
    },
    show: function (category) {
      this.category = category;
      this.view = new CategoryNameView.categoryNameView({ model: this.category });

      if (this.category.isNew()) {
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#categoryDefaultNameText");
          },
          this,
        );
      }
      this.showRegion(this.view);
    },
    nameError: function (errorMessage) {
      this.view.nameError(errorMessage);
    },
  });

  return CategoryNamesController;
});
